import { useState, useEffect, useCallback } from 'react';
import { clientAPI, Client } from '../api/clients';
import { useAuth } from '../contexts/AuthContext';

export const useClients = () => {
  const { user } = useAuth();
  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchClients = useCallback(async () => {
    // ⛔ SÉCURITÉ : Ne pas charger les données si pas d'utilisateur ou si admin sans agence
    if (!user) {
      console.log('⛔ Pas d\'utilisateur connecté');
      setIsLoading(false);
      return;
    }

    // ⛔ Les admins système (sans agency_id) ne voient pas de clients
    if (!user.agency_id) {
      console.log('⛔ Admin système : pas d\'agence associée, pas de clients');
      setClients([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      console.log('🔒 Fetching clients for agency_id:', user.agency_id);
      // ✅ FILTRE PAR AGENCE : Ne récupérer QUE les clients de l'agence de l'utilisateur
      const data = await clientAPI.getAll({ agency_id: user.agency_id });
      console.log('✅ Clients loaded for agency', user.agency_id, ':', data.length, 'clients');
      setClients(data);
    } catch (error) {
      console.error('Failed to fetch clients:', error);
      setError('Erreur lors du chargement des clients');
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return { clients, isLoading, error, refetch: fetchClients };
};